module.exports = new __parcel__URL__("train_50_inactive.c24411bb.png").toString();